<template>
    <b-modal
      size="md"
      :hideFooter="true"
      :hideHeader="true"
      centered
      id="deleteTestModal"
    >
      <template slot="default">
        <b-row>
          <b-col class="float-left">
            <em class="fas fa-lg fa-exclamation"></em>
          </b-col>
        </b-row>
        <b-container class="confirm-modal-cnt">
          <b-row class="text-center mt-2">
            <h6 class="confirm-modal-text text-center w-100">
              Вы действительно хотите удалить данный тест?
            </h6>
          </b-row>
          <b-row>
            <b-col sm="12" md="6">
              <b-button @click="deleteTest" class="confirm-modal-btn" variant="primary">
                Удалить
              </b-button>
            </b-col>
            <b-col sm="12" md="6">
              <b-button @click="closeModal" class="confirm-modal-btn" variant="outline-primary">
                Отмена
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>
</template>

<script>

import TestAPI from '@/api/test'
import RouteMixin from '@/components/helpers/mixins/route-mixin'

export default {
  name: 'DeleteTestModal',
  mixins: [RouteMixin],
  methods: {
    closeModal() {
      this.$bvModal.hide('deleteTestModal')
    },
    deleteTest() {
      TestAPI.deleteTest(this.$route.params.courseBookId, this.$route.params.sectionId)
        .then((response) => {
          this.$router.push(`${this.$_getCourseRoutePrefix(this.$route.path)}${this.$route.params.courseBookId}`)
          this.$emit('delete-test')
        })
    }
  }
}
</script>

<style scoped lang="scss">

  .confirm-modal-btn {
    width: 100%;
  }

  .confirm-modal-text {
    text-align: center;
    margin-bottom: 20px;
  }

  .resetName {
    width: 100%;
    margin-bottom: 20px;
  }

</style>
